var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 0C7.22018 0 7.5 0.279822 7.5 0.625V5.625C7.5 6.66053 6.66053 7.5 5.625 7.5H0.625C0.279822 7.5 0 7.22018 0 6.875C0 6.52982 0.279822 6.25 0.625 6.25H5.625C5.97018 6.25 6.25 5.97018 6.25 5.625V0.625C6.25 0.279822 6.52982 0 6.875 0ZM13.125 0C13.4702 0 13.75 0.279822 13.75 0.625V5.625C13.75 5.97018 14.0298 6.25 14.375 6.25H19.375C19.7202 6.25 20 6.52982 20 6.875C20 7.22018 19.7202 7.5 19.375 7.5H14.375C13.3395 7.5 12.5 6.66053 12.5 5.625V0.625C12.5 0.279822 12.7798 0 13.125 0ZM0 13.125C0 12.7798 0.279822 12.5 0.625 12.5H5.625C6.66053 12.5 7.5 13.3395 7.5 14.375V19.375C7.5 19.7202 7.22018 20 6.875 20C6.52982 20 6.25 19.7202 6.25 19.375V14.375C6.25 14.0298 5.97018 13.75 5.625 13.75H0.625C0.279822 13.75 0 13.4702 0 13.125ZM12.5 14.375C12.5 13.3395 13.3395 12.5 14.375 12.5H19.375C19.7202 12.5 20 12.7798 20 13.125C20 13.4702 19.7202 13.75 19.375 13.75H14.375C14.0298 13.75 13.75 14.0298 13.75 14.375V19.375C13.75 19.7202 13.4702 20 13.125 20C12.7798 20 12.5 19.7202 12.5 19.375V14.375Z",
    fill: "#202123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/exitFullScreen.a1002163ed3ea8fde4bdb3fa781bdd37.svg";
export { ForwardRef as ReactComponent };